export { default as WidgetError } from './WidgetError'
